$(function(){
    if ($('.farm-filter-result #ulResults li').length == '0'){
        $('.get-started-notice').show();
    }else{
        $('.get-started-notice').hide();
    }
})